import { PaymentProvider } from './settings.model';

export enum PaymentMethodsEndpoints {
  ROOT = '/payment-methods',
  ADMIN = '/admin',
}

export const staticPaymentMethodsEndpoints = {
  GET_PAYMENT_METHODS: `${PaymentMethodsEndpoints.ROOT}${PaymentMethodsEndpoints.ADMIN}`,
};

export const getPaymentMethodsEndpoints = ({ paymentMethodId }: { paymentMethodId: string }) => ({
  UPDATE_PAYMENT_METHOD: `${PaymentMethodsEndpoints.ROOT}/${paymentMethodId}`,
});

export interface IPaymentMethod {
  id: string;
  code: PaymentProvider;
  enabled: boolean;
  channelId: number;
}

// ============== DTO ==============

export interface IGetPaymentMethodsDTO {
  channelId: number;
}

export interface IUpdatePaymentMethodDTO {
  id: string;
  enabled: boolean;
}

// ============== Response ==============

export type IGetPaymentMethodsResponse = IPaymentMethod[];

export type IUpdatePaymentMethodResponse = IPaymentMethod;
